import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, QC_LIST } from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  qcList: [],
  successMessage: "",
  error: "",
};

// Generate pening , fulfilled and rejected action type
export const fetchQCList = createAsyncThunk(
  "qcList/fetchQCList.",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(BASE_URL + QC_LIST, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        return response.data.qc_data;
      }
    } catch (error) {
      console.log("error: ", error);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// Generate pening , fulfilled and rejected action type
const qcListSlice = createSlice({
  name: "purchase",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchQCList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchQCList.fulfilled, (state, action) => {
      state.loading = false;
      state.qcList = action.payload;
      state.error = "";
    });
    builder.addCase(fetchQCList.rejected, (state, action) => {
      state.loading = false;
      state.qcList = [];
      state.error = action.error.message;
    });
  },
});

export default qcListSlice.reducer;
